namespace GeniuzPOS.Purchase {
    export namespace PoPo06PendingCNforCnrtvService {
        export const baseUrl = 'Purchase/PoPo06PendingCNforCnrtv';

        export declare function Create(request: Serenity.SaveRequest<PoPo06PendingCNforCnrtvRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PoPo06PendingCNforCnrtvRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PoPo06PendingCNforCnrtvRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PoPo06PendingCNforCnrtvRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/PoPo06PendingCNforCnrtv/Create",
            Update = "Purchase/PoPo06PendingCNforCnrtv/Update",
            Delete = "Purchase/PoPo06PendingCNforCnrtv/Delete",
            Retrieve = "Purchase/PoPo06PendingCNforCnrtv/Retrieve",
            List = "Purchase/PoPo06PendingCNforCnrtv/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PoPo06PendingCNforCnrtvService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
